import { createOTPModalInstance } from "@js/apps/common/forms/fields/otp/otp-auth-modal";

export const {
  openAddWithdrawalMethodOTPModal,
  closeAddWithdrawalMethodOTPModal,
  AddWithdrawalMethodOTPModalInstance,
} = createOTPModalInstance("addWithdrawalMethodOTPModal");
